import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <motion.nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-background/80 backdrop-blur-md py-4 shadow-lg' : 'bg-transparent py-6'}`} initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.8,
    ease: 'easeOut'
  }} data-id="element-138">
      <div className="container mx-auto px-6 flex justify-between items-center" data-id="element-139">
        <motion.div className="font-serif text-2xl font-bold text-primary tracking-widest cursor-pointer" whileHover={{
        scale: 1.05
      }} onClick={() => window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })} data-id="element-140">
          SOY JOHA
        </motion.div>
        <motion.button className="hidden md:block border border-primary text-primary px-6 py-2 rounded-full hover:bg-primary hover:text-background transition-colors duration-300 text-sm tracking-wider font-medium" whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} onClick={() => document.getElementById('cta')?.scrollIntoView({
        behavior: 'smooth'
      })} data-id="element-141">
          CONTACTAR
        </motion.button>
      </div>
    </motion.nav>;
};